import React, { createContext, useState, useContext, useMemo } from 'react';

import EnglishText from '../../Translations/en-US';
import SpanishText from '../../Translations/es-MX';

import DEFAULT_THEME from '../../Theme/default';

// eslint-disable-next-line no-unused-vars
const themes = {
    light: DEFAULT_THEME,
}

const translations = {
    en: EnglishText,
    es: SpanishText,
};

const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [theme, setTheme] = useState('default'); // or 'dark'
    const [language, setLanguage] = useState('en'); // or 'es'

    const toggleTheme = () => {
        setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
    };

    const switchLanguage = (lang) => {
        if (translations[lang]) {
            setLanguage(lang);
        }
    };

    const t = (key) => {
        return translations[language]?.[key] || key;
    };

    const contextValue = useMemo(() => ({
        theme,
        toggleTheme,
        language,
        switchLanguage,
        t,
    }), [theme, language]);

    return (
        <AppContext.Provider value={contextValue}>
        <div className={`app ${theme}`}>
            {children}
        </div>
        </AppContext.Provider>
    );
};

// Custom hook
export const useAppContext = () => useContext(AppContext);
